// extracted by mini-css-extract-plugin
export default {"root":"Button_root__6s-py","disabled":"Button_disabled__mIWyD","secondary":"Button_secondary__yvPxZ"};